module.exports = __webpack_public_path__ + "static/img/9.9fc6ce1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/10/eng/9.png
// module id = oR+d
// module chunks = 0